var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-loading',{attrs:{"is-full-page":true,"active":_vm.isLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }